"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = exports.PopoverWithoutTransition = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

var _styledConfig = require("styled-config");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  max-width: 276px;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  line-height: 1.5;\n  text-align: left;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: ", ";\n  word-wrap: break-word;\n  background-color: ", ";\n  background-clip: padding-box;\n  border: ", " ", ";\n  border-radius: ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      margin-top: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var margin = function margin(props) {
  if (props.top) {
    return (0, _styledComponents.css)(_templateObject(), (0, _styledConfig.getMargin)(props, 'popover', 'topBottom'));
  } else if (props.left) {
    return (0, _styledComponents.css)(_templateObject2(), (0, _styledConfig.getMargin)(props, 'popover', 'leftRight'));
  } else if (props.bottom) {
    return (0, _styledComponents.css)(_templateObject3(), (0, _styledConfig.getMargin)(props, 'popover', 'bottomTop'));
  }

  return (0, _styledComponents.css)(_templateObject4(), (0, _styledConfig.getMargin)(props, 'popover', 'rightLeft'));
};

var PopoverWithoutTransition = (0, _styledComponents["default"])(_styledBaseComponents.Div)(_templateObject5(), function (props) {
  return (0, _styledConfig.getFontFamily)(props, 'popover', 'default');
}, function (props) {
  return (0, _styledConfig.getFontWeight)(props, 'popover', 'default');
}, function (props) {
  return (0, _styledConfig.getFontSize)(props, 'popover', 'sm');
}, function (props) {
  return (0, _styledConfig.getColor)(props, 'popover', 'backgroundColor');
}, function (props) {
  return (0, _styledConfig.getBorder)(props, 'popover', 'default');
}, function (props) {
  return (0, _styledConfig.getColor)(props, 'popover', 'borderColor');
}, function (props) {
  return (0, _styledConfig.getBorderRadius)(props, 'popover', 'lg');
}, function (props) {
  return margin(props);
});
exports.PopoverWithoutTransition = PopoverWithoutTransition;
PopoverWithoutTransition.defaultProps = {
  theme: _styledConfig.theme
};

var Popover = _react["default"].forwardRef(function (props, ref) {
  var hidden = props.hidden,
      children = props.children,
      transitionProps = props.transitionProps,
      rest = _objectWithoutProperties(props, ["hidden", "children", "transitionProps"]);

  return _react["default"].createElement(_styledBaseComponents.Transition, _extends({
    noInitialEnter: true,
    hidden: hidden,
    duration: 250,
    ref: ref
  }, transitionProps), _react["default"].createElement(PopoverWithoutTransition, rest, children));
});

exports.Popover = Popover;